/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { CriteriaResultCellSchemaEvidenceItem } from './criteriaResultCellSchemaEvidenceItem';
import type { CriteriaResultCellSchemaMatch } from './criteriaResultCellSchemaMatch';

/**
 * Per-criterion cell on a talent-search result card.
 */
export interface CriteriaResultCellSchema {
  criterion_id: string;
  label: string;
  match?: CriteriaResultCellSchemaMatch;
  reasoning?: string | null;
  evidence?: CriteriaResultCellSchemaEvidenceItem[];
}
